import {
  searchNews,
  getNews,
  addNews,
  editNews,
  deleteNews,
  editNewsTop,
  editNewsStatus
} from '@/api/NewsController'
import common from '@/utils/common'

const news = {
  namespaced: true,
  state: {
    dataDialogVisible: false,
    pageLoading: true,
    searchQuery: {
      keywords: '',
      status: '',
      rangeTime: ''
    },
    listQuery: {
      params: {
        pageSize: common.pagination.pageSize,
        pageNum: 1
      },
      data: {}
    },
    editData: {
      id: '',
      title: '',
      content: '',
      top: '',
      imageUrl: '',
      startTime: '',
      endTime: '',
      sort: ''
    },
    dataList: {
      total: 0
    }
  },
  mutations: {
    UPDATE_STATE: (state, data) => {
      state[data.key] = data.val
    },
    UPDATE_SEARCH_QUERY: (state, data) => {
      state.searchQuery[data.key] = data.val
    },
    SET_LIST_QUERY: (state, query) => {
      Object.keys(query).forEach((key) => {
        state.listQuery.params[key] = query[key]
      });
    },
    SET_EDIT_OBJ: (state, data) => {
      Object.keys(data).forEach((key) => {
        state.editData[key] = data[key]
      })
    },
    SET_EDIT: (state, data) => {
      state.editData[data.key] = data.val
    },
    SET_SEARCH_QUERY_DEFAULT: (state) => {
      Object.keys(state.searchQuery).forEach(key => {
        state.searchQuery[key] = ''
      })
    },
    SET_EDIT_DEFAULT: (state) => {
      Object.keys(state.editData).forEach(key => {
        state.editData[key] = ''
      })
    },
    SET_PAGE_DEFAULT: (state) => {
      state.listQuery.params.pageNum = 1
    }
  },
  actions: {
    DoSearch(context) {
      return new Promise((resolve, reject) => {
        context.commit('SET_PAGE_DEFAULT')
        context.commit('UPDATE_STATE', { key: 'pageLoading', val: true })
        searchNews(context.state.searchQuery).then(res => {
          context.commit('UPDATE_STATE', { key: 'pageLoading', val: false })
          context.commit('UPDATE_STATE', { key: 'dataList', val: res.data })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    TriggerTop(context, data) {
      return new Promise((resolve, reject) => {
        editNewsTop(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    TriggerStatus(context, data) {
      return new Promise((resolve, reject) => {
        editNewsStatus(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetList(context) {
      return new Promise((resolve, reject) => {
        context.commit('UPDATE_STATE', { key: 'pageLoading', val: true })
        getNews(context.state.listQuery).then(res => {
          context.commit('UPDATE_STATE', { key: 'pageLoading', val: false })
          context.commit('UPDATE_STATE', { key: 'dataList', val: res.data })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Add(context) {
      return new Promise((resolve, reject) => {
        addNews(context.state.editData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Edit(context) {
      return new Promise((resolve, reject) => {
        editNews(context.state.editData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    Delete(context, data) {
      return new Promise((resolve, reject) => {
        deleteNews(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  getters: {
    getSwitchList() {
      let arr = common.switch
      let newArr = Object.keys(arr).map(key => {
        return { value: key, label: arr[key] }
      })
      newArr.unshift({ value: '', label: common.setting.all })
      return newArr
    }
  }
}

export default news
